// extracted by mini-css-extract-plugin
export default {"wrapper":"nameform_wrapper__Umi25","imageWrapper":"nameform_imageWrapper__HItw9","right":"nameform_right__U62+L","inputWrapper":"nameform_inputWrapper__sxyAO"};